import { Button, Paper, Stack, Typography } from "@mui/material";
import { useSignOutAndReturn } from "Hooks/useSignOutAndReturn";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Sso.Consent;

type Props = {
  appName: string;
};

// The partner asked for a session younger than the current one (max_age / prompt=login).
export const SsoReauthenticationCard = ({ appName }: Props) => {
  const { t } = useResource();
  const signInAgain = useSignOutAndReturn();

  return (
    <Paper>
      <Stack gap={3} padding={3}>
        <Typography variant="h5">{t(RESOURCES.ReauthTitle)}</Typography>
        <Typography>{t(RESOURCES.ReauthText, { app: appName })}</Typography>
        <Stack direction="row" justifyContent="flex-end">
          <Button variant="contained" onClick={signInAgain}>
            {t(RESOURCES.ReauthButton)}
          </Button>
        </Stack>
      </Stack>
    </Paper>
  );
};
